export default "__VITE_ASSET__BdnPAcR9__"